import { getValue, update } from '@kundinos/nanostores';

import * as TextileFiltrator from '@Stores/TextileFiltrator';
import collectCollections from './helpers/collectCollections';
import getNumberOfFilteredFabrics from './helpers/getNumberOfFilteredFabrics';
import {
  orderFabricsStore,
  collectionsStore,
  tagsTypesStore,
  colorsStore,
  groupsStore,
  group,
} from './stores';

import type { OrderFabricsData } from './typings';

export const init = (initial: OrderFabricsData): void => {
  const orderFabrics = getValue(orderFabricsStore);
  const allCollections = collectCollections(initial);

  orderFabricsStore.set({ ...orderFabrics, allCollections });
  collectionsStore.set(allCollections);
  colorsStore.set(initial.tags.colors);
  tagsTypesStore.set(initial.tags.types);
  TextileFiltrator.init(initial.tags);
  TextileFiltrator.updateTotalCount(getNumberOfFilteredFabrics());

  // Update total count of collections when change filters
  TextileFiltrator.getStores().filtratorStore.listen(() => {
    TextileFiltrator.updateTotalCount(getNumberOfFilteredFabrics());
  });

  TextileFiltrator.getStores().groupsStore.listen((groupBy) => {
    update(groupsStore, () => group(groupBy.find((item) => item.selected).id));
  });
};

export default init;
